import axiosInstance from "../utils/axiosInstance";
import { Settings } from "../interfaces/settings.interface";

class SettingsApi {

  getSettings(): Promise<Settings> {
    const apiUrl = `/b2c2b/api/v1/settings`;

    return axiosInstance.get(apiUrl)
      .then(response => Promise.resolve(response.data as Settings));
  }
}

export default new SettingsApi();
